<div class="container mt-lg-4">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
    [defaultSort]="0"
  ></fgbcl-marketplace-list>
</div>
